import { styled } from '@mui/material/styles';
import {
  TableCell,
  TableRow,
  TableHead,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import { colors } from '../tokens/colors';
import { typography } from '../tokens/typography';
import { spacing } from '../tokens/spacing';

// ============================================
// Table Header Components
// ============================================

export const StyledTableHead = styled(TableHead)({
  // height: spacing.table.headerHeight,
  backgroundColor: colors.table.headerBg
});

export const HeaderCell = styled(TableCell)({
  backgroundColor: colors.table.headerBg,
  color: colors.table.headerText,
  cursor: 'pointer',
  fontSize: typography.fontSize.sm,
  fontWeight: typography.fontWeight.semibold,
  textAlign: 'center',
  whiteSpace: 'nowrap',
  userSelect: 'none',

  '&:hover': {
    backgroundColor: colors.neutral.grey[800]
  }
});

export const HeaderCellStatic = styled(HeaderCell)({
  cursor: 'default',
  '&:hover': {
    backgroundColor: colors.table.headerBg
  }
});

// ============================================
// Table Row Components
// ============================================

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  // '&:nth-of-type(odd)': {
  //   backgroundColor: colors.table.rowOddBg,
  // },
  // '&:nth-of-type(even)': {
  //   backgroundColor: colors.table.rowEvenBg,
  // },
  backgroundColor: colors.table.rowEvenBg,
  '&:hover': {
    backgroundColor: colors.table.hoverBg
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

export const ClickableTableRow = styled(StyledTableRow)({
  cursor: 'pointer'
});

// ============================================
// Table Cell Components
// ============================================

export const BaseCell = styled(TableCell)({
  fontSize: typography.fontSize.sm,
  fontWeight: typography.fontWeight.semibold,
  textAlign: 'center',
  padding: spacing.table.cellPadding
});

export const BorderedCell = styled(BaseCell)({
  borderLeft: `1px solid ${colors.table.borderColor}`,
  borderRight: `1px solid ${colors.table.borderColor}`,
  borderRadius: 0
});

export const LeftBorderedCell = styled(BaseCell)({
  borderLeft: `1px solid ${colors.table.borderColor}`,
  borderRadius: 0
});

export const RightBorderedCell = styled(BaseCell)({
  borderRight: `1px solid ${colors.table.borderColor}`,
  borderRadius: 0
});

// ============================================
// Cell Text Components
// ============================================

export const CellText = styled(Typography)({
  fontWeight: typography.fontWeight.semibold,
  color: colors.text.secondary,
  fontSize: typography.fontSize.md
});

export const CellTextPrimary = styled(CellText)({
  color: colors.text.primary
});

export const CellTextBold = styled(Typography)({
  fontWeight: typography.fontWeight.extrabold,
  color: colors.neutral.black,
  fontSize: typography.fontSize.base
});

export const CellTextAccent = styled(Typography)({
  fontWeight: typography.fontWeight.semibold,
  color: colors.accent.blue,
  fontSize: typography.fontSize.sm
});

// ============================================
// Header Text Components
// ============================================

export const HeaderText = styled(Typography)({
  fontWeight: typography.fontWeight.extrabold,
  color: colors.table.headerText,
  fontSize: typography.fontSize.sm
});

export const HeaderTextAccent = styled(Typography)({
  fontWeight: typography.fontWeight.semibold,
  color: colors.accent.blue,
  fontSize: typography.fontSize.sm
});

// ============================================
// Expandable Cell Components (Accordion)
// ============================================

export const CellAccordion = styled(Accordion)({
  boxShadow: 'none',
  '&:before': {
    display: 'none'
  },
  '&.Mui-expanded': {
    margin: 0
  }
});

export const CellAccordionSummary = styled(AccordionSummary)({
  display: 'flex',
  justifyContent: 'center',
  minHeight: 'auto',
  padding: 0,
  '&.Mui-expanded': {
    minHeight: 'auto'
  },
  '& .MuiAccordionSummary-content': {
    margin: 0,
    justifyContent: 'center'
  }
});

export const CellAccordionDetails = styled(AccordionDetails)({
  flexGrow: 1,
  padding: spacing.xs
});

export const AccordionTitle = styled(Typography)({
  fontWeight: typography.fontWeight.bold,
  fontSize: typography.fontSize.md,
  textAlign: 'center'
});

// ============================================
// Utility Components
// ============================================

export const EmptyText = styled(Typography)({
  fontWeight: typography.fontWeight.bold,
  fontSize: typography.fontSize.md,
  textAlign: 'left',
  paddingLeft: '18px'
});

export const ClickableCell = styled(BaseCell)({
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: colors.table.hoverBg
  }
});
